import { Table } from "antd";
import DefinitionsData from '../../data/definitionsData.json'
import { getCarrierByDomain } from "../../domain";
import { getApplicableSections } from "../../utils/functionUtils";
import { useCentralStore } from "../../store/appContext";

const ProgramSummaryGlossary = ({ onClose, selectedTab, projectName, theme }) => {
    const [{ carrierThemeData }, ] = useCentralStore()
    const srData = DefinitionsData['ProgramSummarySR']
    const tsData = DefinitionsData[`${getCarrierByDomain()?.toLowerCase()}TsData`]
    const starhubCustomerSLAData = DefinitionsData[`${getCarrierByDomain()?.toLowerCase()}ProgramSummaryCustomerSLA`]


    let tableColumns = [
        {
            title: "Report/Metric",
            dataIndex: "report/metric",
            key: "report/metric",
            width: 220,
            className: "!rounded-none",
        },
        {
            title: 'Definition',
            dataIndex: 'definition',
            key: 'definition',
            width: 220
        },
    ];

    let starhubCustomerSLAColumns = [
        {
            title: "CATEGORY",
            dataIndex: "CATEGORY",
            key: "CATEGORY",
            width: 220,
            className: "!rounded-none",
        },
        {
            title: 'CUSTOMER SERVICE SLA',
            dataIndex: 'CUSTOMERSERVICESLA',
            key: 'CUSTOMERSERVICESLA',
            width: 220
        },
        {
            title: 'CALCULATION METHODOLOGY',
            dataIndex: 'CALCULATIONMETHODOLOGY',
            key: 'CALCULATIONMETHODOLOGY',
            width: 220
        },
    ];

    const tableColumnsTechSLA = [
        {
            title: 'Category',
            width: 220,
            dataIndex: 'category',
            onCell: (_, index) => {
                if (index === 1) {
                    return {
                        rowSpan: 6,
                    };
                }
                if (index === 7) {
                    return {
                        rowSpan: 4,
                    };
                }
                if (index === 2 || index === 3 || index === 4 || index === 5 || index === 6 || index === 8 || index === 9 || index === 10) {
                    return {
                        rowSpan: 0,
                    };
                }
                return {};
            },
        },
        {
            title: 'Description',
            dataIndex: 'description',
            width: 280
        },
        {
            title: 'Technical SLA',
            dataIndex: 'technicalSLA',
            width: 220
        },
        {
            title: 'Minimum Service Performance',
            dataIndex: 'minimumServicePerformance',
            width: 220
        },
    ];

    const dynamicStyle = {
        '--th-header': theme?.colors?.textWhiteColor,
    }

    return (
        <div className={`w-full mx-auto rounded-xl`}>
            {getApplicableSections(carrierThemeData?.applicableSections, 'PgmSummarySRGlossary') &&
                <>
                    <p className='mt-2 w-full text-[#363636] font-semibold text-xl'>Service Requests</p>
                    <Table
                        columns={tableColumns}
                        dataSource={srData}
                        style={dynamicStyle}
                        rowKey="data"
                        key="data"
                        pagination={false}
                        className="table-css border-current border-white hz-scrollbar pb-2 mt-5"
                    />
            </>
            }
            <p className='mt-2 w-full text-[#363636] font-semibold text-xl'>Customer SLA</p>
            <Table
                columns={starhubCustomerSLAColumns}
                dataSource={starhubCustomerSLAData}
                style={dynamicStyle}
                rowKey="data"
                key="data"
                pagination={false}
                className="table-css border-current border-white hz-scrollbar pb-2 mt-5"
            />
            <p className='mt-2 w-full text-[#363636] font-semibold text-xl'>Technical SLA</p>
            <Table
                columns={tableColumnsTechSLA}
                dataSource={tsData}
                style={dynamicStyle}
                rowKey="data"
                key="data"
                pagination={false}
                className="table-css border-current border-white hz-scrollbar pb-2 mt-5"
            />
        </div>
    );
};

export default ProgramSummaryGlossary;
